<template>
  <div class="hjqy">
    <headerBanner :bannerUrl='domain+cate.bgpic'></headerBanner>
    <div class="common_title clearfix">
      <div class="icon"><i class="icons i8"></i></div><p>{{cate.name}}</p>
    </div>
    <div class="ljhjqy_detail">
      <template v-for='item in data'>
        <router-link :to="'/jchg/list/'+item.id">
          <div class="ljhjqy_detail_item EY_Regular">
              {{item.name}}
          </div>
        </router-link>
      </template>
    </div>
  </div>
</template>

<script>
import headerBanner from '@/components/public/header'
export default {
  name: 'jchg',
  data () {
    return {
      data: '',
      domain:'https://eympe.vapps.me',
      cate:''
    }
  },
  components:{
    headerBanner:headerBanner
  },
  mounted:function(){
     this.$http.post('https://eympe.vapps.me/index.php?g=Index&m=Index&a=get_category',
       {
          cid:5
        },
       {emulateJSON : true})
   .then((response) => {
         this.data=response.body.data;
         this.cate = response.body.cate
         console.log(response)
         
     })
  }
}
</script>

<style scoped>
  i.i7{
    width: 0.41rem;
    height: 0.24rem;
    background-position: -0.63rem -2.09rem;
  }
  i.i8{
    width: 0.36rem;
    height: 0.4rem;
    background-position: -2.18rem -1.28rem;
  }
  .ljhjqy_detail{
    padding: 0 0.36rem;
  }
  .ljhjqy_detail_item{
    padding: 0.15rem  0.12rem;
    border-bottom: 1px dashed #7d7e81;
    font-size: 0.2rem;
    color: #000000;
  }
  .ljhjqy_detail a:first-child .ljhjqy_detail_item{
    padding-top: 0;
  }
  .ljhjqy_detail_item:before{
    display: inline-block;
    content: '';
    width: 0;
    height: 0;
    border-top: 0.06rem solid transparent;
    border-left: 0.12rem  solid #6d6e71;
    border-bottom: 0.06rem  solid transparent;
  }
  
</style>


// WEBPACK FOOTER //
// src/components/jchgList.vue